import { Col, Input, Row } from "antd";
import { FieldArray, FieldArrayRenderProps, Form, Formik } from "formik";
import React, { FC, Fragment, useEffect, useState } from "react";
import ButtonComponent from "../../../../shared/components/ButtonComponent";
import InputField from "../../../../shared/components/InputField";
import RadioGroup from "../../../../shared/components/RadioGroup";
import UIModal from "../../../../shared/components/UIModal";
import UIStepper from "../../../../shared/components/UIStepper";
import Question from "./Question";
import { Collapse } from "antd";
import {
  CaretRightOutlined,
  MinusCircleOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import "./addExercise.scss";
import { ExerciseModal } from "../../../../models/ExerciseModal/Exercise.model";
import { serialize } from "serializr";
import ExcerciseService from "../../../../services/ExcerciseService/excercise.service";
import QuestionService from "../../../../services/QuestionService/Question.service";
import QuestionModel, {
  QuestionAttachmentModel,
} from "../../../../models/ExerciseModal/Question.model";
import { isIndexedAccessTypeNode } from "typescript";
import ToggleSwitch from "../../../../shared/components/ToggleSwitch";
import { RouteComponentProps, withRouter } from "react-router";
import { ExamExerciseService } from "../../../../services/ExamService/ExerciseService/exercise.service";
import { ExamExerciseQuestionModel } from "../../../../models/ExamModels/ExerciseModel/question.model";
import { ExamExerciseQuestionService } from "../../../../services/ExamService/ExerciseService/question.service";

const { Panel } = Collapse;
interface AddExerciseProps extends RouteComponentProps {
  visible: boolean;
  exercise?: any;
  activeChapter?: any;
  closeModalHandler: () => void;
  refreshList?: any;
}
interface ExerciseValues {
  title: string;
  description: string;
  timerOptions: string;
  time: number | undefined;
  questions: QuestionType[];
  isActive: boolean;
}

export interface QuestionType {
  question: string;
  correctAnswer: string;
  option1: string;
  option2: string;
  option3: string;
  noOptions: boolean;
  solution: string;
  questionAttachments: any;
  questionSolutionAttachments: any;
  questionOptionImages: any;
  imageUrl: any;
  id: any;
}

const TimeOptions = [
  {
    label: "No Timer",
    value: "no_timer",
  },
  {
    label: "Whole Quiz",
    value: "whole_quiz",
  },
  {
    label: "Per Question",
    value: "per_question",
  },
];

const getTimeType = (selected: string) => {
  switch (selected) {
    case "whole_quiz":
      return "mins";
    case "per_question":
      return "sec";
    default:
      return "";
  }
};

const AddExercise: FC<AddExerciseProps> = ({
  visible,
  activeChapter,
  closeModalHandler,
  exercise = null,
  refreshList,
  location,
}) => {
  const [stepper, setStepper] = useState(0);
  const [active, setActive] = useState<number[]>([]);
  const [exerciseId, setExerciseId] = useState();
  const [isActive, setIsActive] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState();
  const [initialValue, setInitialValue] = useState<ExerciseValues>({
    title: "",
    description: "",
    timerOptions: "no_timer",
    time: 0,
    questions: [],
    isActive: false,
  });
  const handleSubmit = (values: ExerciseValues) => {};

  useEffect(() => {
    if (exercise) {
      setIsActive(exercise?.isActive);
      setExerciseId(exercise?.id);
      location.pathname.includes("exams")
        ? ExamExerciseQuestionService.getQuestionsbyExerciseId(
            exercise?.id,
            (questions: any) => {
              setInitialValue({
                ...exercise,
                questions,
              });
            },
            () => {}
          )
        : QuestionService.getQuestionsByExercise(
            { excercise_id: exercise?.id },
            (questions) => {
              setInitialValue({
                ...exercise,
                questions,
              });
            },
            () => {}
          );
    }
  }, [exercise]);

  const handleAddquestion = (arrayHelper: FieldArrayRenderProps) => {
    const initialState = {
      question: "",
      correctAnswer: "",
      option1: null,
      option2: null,
      option3: null,
      option4: null,
      image_option1: null,
      image_option2: null,
      image_option3: null,
      image_option4: null,
      noOptions: false,
      solution: "",
      questionAttachments: [],
      questionSolutionAttachments: [],
      questionOptionImages: [],

      attachment: undefined,
      imageUrl: undefined,
    };
    arrayHelper.push(initialState);
  };

  const createNewExercise = (values: QuestionType) => {
    if (location.pathname.includes("exams")) {
      const payload = {
        ...values,
        position: 1,
        examChapterId: activeChapter?.id,
      };
      if (exercise) {
        ExamExerciseService.updateExamExercise(
          exercise?.id,
          values,
          () => {
            setStepper(1);
          },
          () => {
            setStepper(0);
          }
        );
        return;
      }
      ExamExerciseService.createNewExamExercise(
        payload,
        (exercise: any) => {
          console.log(exercise);
          setExerciseId(exercise?.id as any);

          setStepper(1);
        },
        () => {
          setStepper(0);
        }
      );
    } else {
      const payload = {
        ...values,
        position: 1,
        chaptorId: activeChapter?.id,
      };
      if (exercise) {
        ExcerciseService.updateExercise(
          exercise?.id,
          values,
          () => {
            setStepper(1);
          },
          () => {
            setStepper(0);
          }
        );
        return;
      }
      ExcerciseService.createExercise(
        payload,
        (exercise) => {
          setExerciseId(exercise?.id as any);
          setStepper(1);
        },
        () => {
          setStepper(0);
        }
      );
    }
  };

  return (
    <div className="add-exericse__container">
      <Formik
        initialValues={initialValue}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ values, setFieldValue, resetForm }) => (
          <UIModal
            visible={visible}
            closeModal={closeModalHandler}
            onClosed={() => {
              resetForm();
            }}
            submitProps={{
              text: stepper ? "Finish" : "Next",
              clickHandler: () => {
                if (!stepper) {
                  createNewExercise(values as any);
                  return;
                }
                closeModalHandler();
                refreshList();
                setStepper(stepper ? 0 : 1);
              },
            }}
            cancelProps={{
              text: "Cancel",
              clickHandler: () => {
                if (!exercise && stepper) {
                  ExcerciseService.deleteExercise(exerciseId, () => {
                    setStepper(0);
                    closeModalHandler();
                  });
                } else {
                  setStepper(0);
                  closeModalHandler();
                }
              },
            }}
          >
            <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <div className="board-form__title add-content-modal__title">
                {exercise ? "Edit Exercise" : "Add new Exercise"}
              </div>
              <div className="stepper__wrapper">
                <Row>
                  <Col span={10}>
                    <UIStepper current={stepper} />
                  </Col>
                  <Col span={14}>
                    <ToggleSwitch
                      checked={isActive}
                      handleChange={(checked: any) => {
                        if (exerciseId) {
                          location.pathname.includes("exams")
                            ? ExamExerciseService.updateExamExercise(
                                exerciseId,
                                {
                                  isActive: checked,
                                },
                                () => {
                                  setFieldValue("isActive", checked);
                                  setIsActive(checked);
                                  refreshList();
                                },
                                () => {}
                              )
                            : ExcerciseService.updateExercise(
                                exerciseId,
                                { isActive: checked },
                                () => {
                                  setFieldValue("isActive", checked);
                                  setIsActive(checked);
                                  refreshList();
                                },
                                () => {}
                              );
                        } else {
                          setFieldValue("isActive", checked);
                          setIsActive(checked);
                        }
                      }}
                    />
                  </Col>
                </Row>
              </div>
              {stepper ? (
                <FieldArray
                  name="questions"
                  render={(arrayHelper) => (
                    <Fragment>
                      <Collapse
                        accordion
                        bordered={false}
                        activeKey={active}
                        className="pj-list-question__collapse"
                        onChange={(key) => {
                          setActive([parseInt(key as string)]);
                        }}
                        expandIcon={({ isActive }) => (
                          <CaretRightOutlined
                            className="collapse-icon__question"
                            rotate={isActive ? 90 : 0}
                          />
                        )}
                        destroyInactivePanel
                      >
                        {values?.questions?.map((_, index) => (
                          <Panel
                            header={`Question ${index + 1}`}
                            key={index}
                            className="site-collapse-custom-panel"
                            extra={
                              <DeleteOutlined
                                className="pj-remove-minus__question"
                                onClick={(event) => {
                                  if (values?.questions[index]?.id) {
                                    if (location.pathname.includes("exams")) {
                                      const question: ExamExerciseQuestionModel =
                                        values?.questions[index];
                                      ExamExerciseQuestionService?.deleteExamExerciseQuestion(
                                        question?.id,
                                        () => {
                                          const questions = values.questions;
                                          questions?.splice(index, 1);
                                          setFieldValue("questions", questions);
                                        },
                                        () => {}
                                      );
                                    } else {
                                      const question: QuestionModel =
                                        values?.questions[index];
                                      QuestionService?.deleteQuestion(
                                        question?.id,
                                        () => {
                                          const questions = values.questions;
                                          questions?.splice(index, 1);
                                          setFieldValue("questions", questions);
                                        },
                                        () => {}
                                      );
                                    }
                                    event?.stopPropagation();
                                  } else {
                                    const questions = values.questions;
                                    questions?.splice(index, 1);
                                    setFieldValue("questions", questions);
                                  }
                                }}
                              />
                            }
                          >
                            <Question
                              index={index}
                              exerciseId={exerciseId}
                              deleteIndex={deleteIndex}
                              value={values.questions[index]}
                              setFieldValue={setFieldValue}
                              showAttachment
                              onCreate={(question, index) => {
                                setActive([-1]);
                                setFieldValue(
                                  "questions",
                                  [...values?.questions]?.map((ques, i) => {
                                    if (i === index) {
                                      return {
                                        ...question,
                                        imageUrl: ques?.imageUrl,
                                      };
                                    }
                                    return ques;
                                  })
                                );
                              }}
                            />
                          </Panel>
                        ))}
                      </Collapse>
                      <ButtonComponent
                        className="pj-add-question"
                        type="ghost"
                        buttonContent="+ Add Question"
                        onClick={() => {
                          setActive([values?.questions?.length]);
                          handleAddquestion(arrayHelper);
                        }}
                      />
                    </Fragment>
                  )}
                />
              ) : (
                <Fragment>
                  <InputField
                    type="text"
                    name="title"
                    title="Exercise Title *"
                    placeholder="Type exercise title"
                    className="mt-5"
                  />
                  <InputField
                    type="textarea"
                    title="Description *"
                    name="description"
                    placeholder="Type Description"
                    rows={4}
                    className="mt-5"
                  />
                  <RadioGroup
                    title="Time Options *"
                    name="timerOptions"
                    options={TimeOptions}
                    displayType="space-between"
                    className="mt-5"
                    value={values?.timerOptions}
                    selectedHandler={(selected: string) => {
                      setFieldValue("timerOptions", selected);
                    }}
                  />
                  <div className="time-selector mt-5">
                    <label htmlFor="time">Time *</label>
                    <Input.Group compact className="time__select mt-3">
                      <Input
                        style={{ width: "10%" }}
                        disabled={values?.timerOptions === "no_timer"}
                        type="number"
                        value={values.time ?? 0}
                        onChange={({ target: { value } }) => {
                          console.log(value);
                          setFieldValue("time", parseFloat(value));
                        }}
                      />

                      <Input
                        style={{ width: "90%" }}
                        value={getTimeType(values?.timerOptions)}
                        disabled={true}
                      />
                    </Input.Group>
                  </div>
                </Fragment>
              )}
            </Form>
          </UIModal>
        )}
      </Formik>
    </div>
  );
};

export default withRouter(AddExercise);
